import React, { useEffect } from 'react';
import { useNavigation } from '@react-navigation/native';

import { OfflineEventModal } from '../components/master/OfflineEventModal';
import { GlobalPageLoader } from '../components/ui/GlobalPageLoader';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { resolveCreateEventAccess } from './events/createEventAccess';

/** CORE-1003 — routed full-screen creation flow on web. */
export const CreateEventScreen: React.FC = () => {
  const navigation = useNavigation<any>();
  const { user, isAuthenticated, isLoading, hasRole } = useAuth();
  const { colors, isDark } = useTheme();
  const access = resolveCreateEventAccess(isLoading, isAuthenticated, hasRole('Master'));

  useEffect(() => {
    if (access === 'loading' || access === 'allowed') return;

    if (access === 'login') {
      navigation.reset({ index: 0, routes: [{ name: 'Login', params: { returnTo: '/events/create' } }] });
      return;
    }

    navigation.reset({ index: 0, routes: [{ name: 'Dashboard' }] });
  }, [access, navigation]);

  if (access !== 'allowed') return <GlobalPageLoader immediate />;

  return (
    <OfflineEventModal
      visible
      screenMode
      onClose={() => {
        if (navigation.canGoBack()) navigation.goBack();
        else navigation.navigate('Dashboard');
      }}
      masterName={user?.resolvedDisplayName || user?.displayName || 'Вы'}
      navigation={navigation}
      isDark={isDark}
      colors={colors}
    />
  );
};

export default CreateEventScreen;
